export const ROLE_OVERRIDE_STORAGE_KEY = 'lk_role_override';

export const readRoleOverride = (): Array<string> | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = localStorage.getItem(ROLE_OVERRIDE_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed;
    }
  } catch {
    return null;
  }

  return null;
};

export const writeRoleOverride = (roles: Array<string> | null) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (roles === null) {
    localStorage.removeItem(ROLE_OVERRIDE_STORAGE_KEY);
    return;
  }

  localStorage.setItem(ROLE_OVERRIDE_STORAGE_KEY, JSON.stringify(roles));
};
